// extracted by mini-css-extract-plugin
export default {"footer":"registerfooter_footer__bdMlD","circle":"registerfooter_circle__sAkjf"};